import { formatMetrics } from './metrics.js';
export const createBrowserLinkFetch = (authStrategy, appName, trackingHeaders, seekHeaders, headers, metricsHandler) => (url, options) => {
    const fetchWithOptions = (tokenData) => {
        const authHeaders = {};
        if (tokenData.authenticated) {
            const { tokenHeader = '', token = '' } = tokenData;
            authHeaders[tokenHeader] = token;
        }
        const modifiedOptions = Object.assign(Object.assign({}, options), { headers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, headers), options === null || options === void 0 ? void 0 : options.headers), trackingHeaders), seekHeaders), authHeaders), { 'X-Seek-Site': appName }) });
        const startTime = Date.now();
        return fetch(url, modifiedOptions).then((response) => {
            metricsHandler === null || metricsHandler === void 0 ? void 0 : metricsHandler(formatMetrics(startTime, response));
            return response;
        });
    };
    return authStrategy
        ? authStrategy
            .get()
            .catch(() => ({ authenticated: false }))
            .then(fetchWithOptions)
        : fetchWithOptions({});
};
//# sourceMappingURL=createBrowserLinkFetch.js.map